module.exports = __webpack_public_path__ + "assets/img/cardfinans@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/cardfinans@2x.png
// module id = 128
// module chunks = 0